module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    key: _vm.getUser && _vm.getUser.id ? _vm.getUser.id : 'header-id',
    staticClass: "menu"
  }, [(!_vm.user) ? _c('div', {
    staticClass: "all-row"
  }, [_c('div', {
    staticClass: "menu-item-button item-menu is-mobile"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('img', {
    staticClass: "is-menu-button",
    attrs: {
      "src": "/static/img/menu_button.svg"
    },
    on: {
      "click": _vm.isMenu
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-menu",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.isAuthModal
    }
  }, [_c('ui_sub_title_text', {
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/human.svg"
    }
  }), _vm._v("Вход\n        ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.isRegModal
    }
  }, [_c('ui_sub_title_text', [_vm._v("\n          Регистрация\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "all-row-logined"
  }, [_c('div', {
    staticClass: "menu-item-button item-menu is-mobile"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('img', {
    staticClass: "is-menu-button",
    attrs: {
      "src": "/static/img/menu_button.svg"
    },
    on: {
      "click": _vm.isMenu
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "left-menu is-desctop"
  }, [_c('div', {
    staticClass: "item-menu left-wrapper"
  }, [_c('ui_sub_title_text', [_c('router-link', {
    attrs: {
      "to": "/deals"
    }
  }, [_vm._v(" Сделки ")])], 1), _vm._v(" "), (_vm.user.role_id == 1) ? [_c('ui_sub_title_text', [_c('router-link', {
    staticClass: "margion-none",
    attrs: {
      "to": "/create_ticket"
    }
  }, [_vm._v("\n              Создать обращение\n            ")])], 1)] : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "margion-none",
    attrs: {
      "to": "/safety"
    }
  }, [_c('ui_sub_title_text', [_vm._v("\n            О безопасной сделке\n          ")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "right-menu"
  }, [_c('div', {
    key: _vm.rerender,
    staticStyle: {
      "position": "relative"
    },
    on: {
      "click": _vm.letter
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/letterIcon.svg"
    }
  }), _vm._v(" "), (_vm.isNew) ? _c('div', {
    staticClass: "red-point"
  }) : _vm._e()]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/colIcon.svg"
    },
    on: {
      "click": _vm.bellClick
    }
  }), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-header",
    attrs: {
      "min-width": "330",
      "offset-y": "",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-avatar', _vm._g(_vm._b({
          staticStyle: {
            "vertical-align": "unset",
            "margin-left": "3%"
          },
          attrs: {
            "size": "61"
          }
        }, 'v-avatar', attrs, false), on), [_c('img', {
          staticStyle: {
            "object-fit": "cover"
          },
          attrs: {
            "src": _vm.user.photo ? (_vm.getApi + "file/" + (_vm.user.photo)) : _vm.customer1,
            "alt": ""
          }
        })])]
      }
    }], null, false, 1663641846)
  }, [_vm._v(" "), _c('v-card', [_c('v-row', {
    staticStyle: {
      "padding": "15px 20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-avatar', {
    staticStyle: {
      "vertical-align": "unset"
    },
    attrs: {
      "size": "61"
    }
  }, [_c('img', {
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.user.photo ? (_vm.getApi + "file/" + (_vm.user.photo)) : _vm.customer1,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "name-email-user"
  }, [_c('v-row', {
    staticClass: "name"
  }, [_vm._v("\n                " + _vm._s(_vm.user.name) + " " + _vm._s(_vm.user.patronymic) + "\n              ")]), _vm._v(" "), _c('v-row', {
    staticClass: "email"
  }, [_vm._v("\n                " + _vm._s(_vm.user.email) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.menuitems), function(item, index) {
    return [_c('v-divider', {
      key: index + Math.floor(Math.random() * (10 - 1 + 1)) + 1 + item.title,
      class: {
        'is-mobile': item.isMobile
      },
      staticStyle: {
        "margin-top": "0 !important",
        "margin-bottom": "0  !important"
      }
    }), _vm._v(" "), (item.met === 'logout') ? _c('v-list-item', {
      key: index + Math.floor(Math.random() * (10 - 1 + 1)) + 1 + item.title,
      class: {
        'is-mobile': item.isMobile
      },
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.logout()
        }
      }
    }, [_c('v-list-item-title', [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (item.met != 'logout') ? _c('v-list-item', {
      key: index + Math.floor(Math.random() * (10 - 1 + 1)) + 1 + item.title,
      class: {
        'is-mobile': item.isMobile
      },
      attrs: {
        "link": "",
        "to": item.href
      }
    }, [_c('v-list-item-title', [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])], 1) : _vm._e()]
  })], 2)], 1)], 1)], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-menu is-mobile"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo-menu-mobile",
    attrs: {
      "src": "/static/img/logo_full.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-menu is-mobile"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo-menu-mobile",
    attrs: {
      "src": "/static/img/logo_full.svg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58c7e81a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/header.vue
// module id = 358
// module chunks = 2